import React,{useState,useEffect} from 'react';
import { Preferences } from '@capacitor/preferences';
import { Toast, Navbar, Nav, Container} from 'react-bootstrap';
import { ListGroup, Row, Col, Image} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Card from './card';
import Single from './single';
import StarLineage from './spread/starlineage';
import Karmic from './spread/karmic';
import HigherGuidance from './spread/higher';
import CurrentInfluence from './spread/current';
import Personal from './spread/personal';
import Free from './spread/free';
import { useSpring, a } from "react-spring";
import { isBrowser, isMobileSafari, isMobile, isIOS } from 'react-device-detect';
import Chakra from './spread/chakra';
import { useLanguage } from '../i18n/LanguageContext';

function Saved(props) {
  const { t } = useLanguage();
  const [items, setItems] = useState([]);
  const [years, setYears] = useState([]);
  const [filter, setFilter] = useState("");
  const [edit, setEdit] = useState(false);
  const [updated, update] = useState(false);
  const [currentCard, setCard] = useState(null);
  const [type, setType] = useState("none");
  const [sortOrder, setSortOrder] = useState("desc"); // "asc" or "desc"

  const [width, setWidth]   = useState(window.outerWidth);
  const [height, setHeight] = useState(window.outerHeight);
  var touchMoved = false;

  const updateDimensions = () => {
    setWidth(window.outerWidth);
    setHeight(window.outerHeight);
  }

  const rotation = () => {
    if (window.screen && window.screen.orientation){
      const {type, angle} = window.screen.orientation;
      if (type.indexOf("portrait") >= 0){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    else{
      var angle = window.orientation;
      if (angle == 0 || angle == 180){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    
  }

  useEffect(() => {
    
    if (isMobile){
      if (window.screen && window.screen.orientation){
        window.screen.orientation.addEventListener("change", rotation);
      }
      else{
        window.addEventListener("orientationchange", rotation);
      }
    }
    else{
      window.addEventListener("resize", updateDimensions);
    }
    
    return function(){
      if (isMobile){
        if (window.screen && window.screen.orientation){
          window.screen.orientation.removeEventListener("change", rotation);
        }
        else{
          window.removeEventListener("orientationchange", rotation);
        }
      }
      else{
        window.removeEventListener("resize", updateDimensions);
      }
    } 
    
  },[]);

  const RollIn = ({ children }) => {
    const props = useSpring({
      from: {transform: 'translate3d(-100%,0,0)', opacity:0},
      to: {transform: 'translate3d(0,0,0)', opacity:1},
      config: {duration:500}
    });
    return <a.div style={props}>{children}</a.div>;
  };


   function handleClick(item){
    //Open card for viewing
    if (!edit){
      setCard(item);
      setType(item.type);
    }
  }

  function handleBack(){
    setType("none");
    getItems();
    props.onSubSelect();
  }

  async function handleDelete(key){
    await Preferences.remove({ key: key });
    var i = items.findIndex(function(item){
      return item.key == key;
    })
    items.splice(i,1);
    setItems(items);
    update(!updated);
  }

  function handleSelect(key){
    if (key == "edit"){
      setEdit(true);
    }
    else if(key == "done"){
      setEdit(false);
      update(!updated);
    }
  }

  function handleFilterSelect(event){
    setFilter(event.target.value);
  }

  async function getItems(){
    //https://capacitorjs.com/docs/apis/storage
    var keys = await Preferences.keys();
    var itemKeys = (keys && keys.keys) ? keys.keys.filter(function(k){ return /^\d+$/.test(k); }) : [];
    var years = [];
    var cardItemsRaw = await Promise.all(itemKeys.map(async (key) => {
      try {
        var itemJson =  await Preferences.get({ key: key });
        if (!itemJson || !itemJson.value) return null;
        var item = JSON.parse(itemJson.value);
        if (!item || !item.type) return null;
        var iconPath;
        if (item.type == "card"){
          iconPath = "cards/" + item.card + ".jpg";
        }
        else {
          iconPath = "graphics/" + item.type + ".png";
        }
        
        item.key = key;
        var dt = new Date(parseInt(key));
        if (isNaN(dt.getTime())) return null;
        item.year = dt.getFullYear();
        if (years.indexOf(item.year)<0){
          years.push(item.year);
        }
        item.path = iconPath;
        return item;
      } catch (err) {
        return null;
      }
    }));

    var cardItems = cardItemsRaw.filter(Boolean);
    setItems(cardItems);
    if (years.length > 0){
      setYears(years.sort());
    }
    
    if (!filter && years.length > 0){
      setFilter(years[years.length - 1]);
    }
    
    Promise.resolve();
  }

  function compare( a, b ) {
    if ( sortOrder === "asc") {
      return a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
    } else {
      return a.key > b.key ? -1 : a.key < b.key ? 1 : 0;
    }
  }
  
  useEffect(() => {
      getItems();
  },[props.refresh]);
    
 function getImage(item){
   if (item.type == 'card'){
    return (<Image src={item.path} thumbnail style={{height: '50px', width: '50px'}} />)
   }
   else{
     return (<Image src={item.path} thumbnail style={{height: '50px', width: '50px'}} />)
   }
  
 }

 function getFilterItems(){
   if (years.length > 1){
     var filterItems = years.map(item =>{
       return (<option>{item}</option>)
     })
     var def = filter;
     if (!def){
      def = years[years.length - 1];
     }
     return (<select defaultValue={def} style={{marginRight:'10px'}} onChange={handleFilterSelect.bind(this)}>{filterItems}</select>);
   }
   else{
     if (filter != years[0]){
       setFilter(years[0]);
     }
     return (<div/>);
   }
 }

 function getListItems(){
   var filteredItems = items.filter(function(item){
     return item && item.year != null && item.year.toString() == filter;
   })
   if (filteredItems.length > 0){
      var listItems = filteredItems.sort(compare).map(item => {
        return (
        <div className="list-group-item list-group-item-dark list-group-item-action" key={item.key} variant={props.theme} action onClick={handleClick.bind(this,item)}>
        <Row>
            <Col xs={3} className="justify-content-center align-self-center mx-auto">{getImage(item)}</Col>
            <Col>
                <div><b>{item.time}</b></div>
                <div className="r2">{item.title}</div>
            </Col>
            <Col xs={1} className="justify-content-center align-self-center mx-auto"><FontAwesomeIcon icon={faTrashAlt}  size='1x' hidden={!edit} onClick={handleDelete.bind(this,item.key)}/></Col>
        </Row>
      </div>)
    });
    return (<ListGroup>
          {listItems}
    </ListGroup>);
   }
   else{
    return (<div className='justify-content-center align-self-center mx-auto text-light' style={{padding:15}}><b><center>{t('saved.noSaved')}</center></b></div>)
   }
 }

 if (type == "card"){
  return (
    <div>
        <Single theme={props.theme} card={currentCard} onBackSelected={handleBack}></Single>
    </div>
  )
 }
 else if (type == "higher"){
  return (
    <div>
        <HigherGuidance theme={props.theme} cards={currentCard} onBackSelected={handleBack}></HigherGuidance>
    </div>
  )
 }
 else if (type == "karmic"){
  return (
    <div>
        <Karmic theme={props.theme} cards={currentCard} onBackSelected={handleBack}></Karmic>
    </div>
  )
 }
 else if (type == "starlineage"){
  return (
    <div>
        <StarLineage theme={props.theme} cards={currentCard} onBackSelected={handleBack}></StarLineage>
    </div>
  )
 }
 else if (type == "personal"){
  return (
    <div>
        <Personal theme={props.theme} cards={currentCard} onBackSelected={handleBack}></Personal>
    </div>
  )
 }
 else if (type == "free"){
  return (
    <div>
        <Free theme={props.theme} cards={currentCard} onBackSelected={handleBack}></Free>
    </div>
  )
 }
 else if (type == "current"){
  return (
    <div>
        <CurrentInfluence theme={props.theme} cards={currentCard} onBackSelected={handleBack}></CurrentInfluence>
    </div>
  )
 }
 else if (type == "chakra"){
  return (
    <div>
        <Chakra theme={props.theme} cards={currentCard} onBackSelected={handleBack}></Chakra>
    </div>
  )
 }
 else{
    var cHeight = '100vh';
    if (isBrowser || isMobileSafari){
      cHeight = height + 'px';
    }
  return (
    <div>
        <Navbar fixed="top" bg={props.theme} variant={props.theme} style={{paddingTop:'calc(env(safe-area-inset-top) + 10px)'}}>
        <Container>
        <Nav style={{width: "100%"}} className="justify-content-end" onSelect={handleSelect}>
          {getFilterItems()}
          <select value={sortOrder} onChange={e => setSortOrder(e.target.value)} style={{marginRight:'10px'}}>
            <option value="desc">{t('saved.newest')}</option>
            <option value="asc">{t('saved.oldest')}</option>
          </select>
          <Nav.Link eventKey="edit" hidden={edit}><FontAwesomeIcon icon={faPen}  size='1x'/> {t('saved.edit')}</Nav.Link>
          <Nav.Link eventKey="done" hidden={!edit}>{t('saved.done')}</Nav.Link>
        </Nav>
        </Container>
      </Navbar>
      <Container fluid style={{paddingTop:'70px',paddingBottom:'85px',overflow:'auto', width:'100%',paddingLeft:'0px', paddingRight:'0px', height:'calc(' + cHeight + ' - 75px - env(safe-area-inset-top))'}}>
      {getListItems()}
      </Container>
    </div>
  )
 }
  
};

export default Saved;